const selectors = {
    
  };
  class templateCollectionJS {
    constructor() {
        // this.loadReviews();
    }

    loadReviews(){
        const reviewsElements = document.querySelectorAll('[data-reviews]');
        let productIds = [];
        reviewsElements.forEach((ele)=>{
          let eleHTML = ele.innerHTML;
          if(eleHTML.length <= 0)
            productIds.push(ele.getAttribute('data-product-id'));
        });
        productIds = productIds.toString();
    
        const options = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        };

        fetch('https://growave.io/api/reviews/products?product_ids='+productIds, options)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
            console.log(response)
        //   let reviewData = response.data;
        //   reviewData.forEach((review)=>{
        //     if(review.avg_rating > 0){
        //       let reviewStarHTML = '';
        //       for(i=1; i<= review.avg_rating; i++){
        //         reviewStarHTML += '<span class="hulk-icon-star-fill" style="color:#ffb800"></span>';
        //       }
        //       let finalReview = `<div class="hulk-pr__review-icon">${reviewStarHTML}<span class="hulk-review-total">${review.total_reviews} ${((review.total_reviews <= 1) ? "Review" : "Reviews")}</span></div>`;
        //       let reviewDiv = document.querySelector(`[data-hulkapps-reviews][data-hulkapps-reviews-product-id="${review.product_id}"]`);
        //       if(reviewDiv) reviewDiv.innerHTML = finalReview;
        //     }
        //   });
        }).catch((error) => {
          console.log(error);
        });
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

 